import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) setShowBanner(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0,zIndex:"101", 
      backgroundColor:"white", color: "black", padding: "20px", 
      textAlign: "center",border:"1px solid black"
    }}>
      <button onClick={()=>setShowBanner(false)} className="border-0" style={{position:"absolute",top:"0",right:"0"}}>x</button>
      <p>We use cookies to improve your experience. Read our <a href="/privacy-policy" style={{ color: "rgb(82, 72, 246)" }}>Privacy Policy</a>.</p>
      <div className="d-flex align-items-center justify-content-center gap-2">
      <button onClick={handleAccept} className="px-3 py-2 new-btn border-0" style={{ marginRight: "10px", padding: "5px 10px",color:"white",borderRadius:"5px" }}>Accept</button>
      <button onClick={handleReject} className="px-3 py-2 new-btn border-0" style={{ padding: "5px 10px",color:"white",borderRadius:"5px" }}>Reject</button>
      </div>
    </div>
  );
}
